import { render, staticRenderFns } from "./gptProfile.vue?vue&type=template&id=49361a1c&scoped=true&"
import script from "./gptProfile.vue?vue&type=script&lang=js&"
export * from "./gptProfile.vue?vue&type=script&lang=js&"
import style0 from "./gptProfile.vue?vue&type=style&index=0&id=49361a1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49361a1c",
  null
  
)

export default component.exports